import { Injectable } from '@angular/core';
import {ReplaySubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AppEventsService {

  private _householdChanged = new ReplaySubject<void>(1);
  householdChanged$ = this._householdChanged.asObservable();

  private _invitationsChanged = new ReplaySubject<void>(1);
  invitationsChanged$ = this._invitationsChanged.asObservable();

  private _stockChanged = new ReplaySubject<void>(1);
  stockChanged$ = this._stockChanged.asObservable();

  private _shoppingListChanged = new ReplaySubject<void>(1);
  shoppingListChanged$ = this._shoppingListChanged.asObservable();

  private _recipeChanged = new ReplaySubject<void>(1);
  recipeChanged$ = this._recipeChanged.asObservable();

  notifyInvitationChanged(): void {
    this._invitationsChanged.next();
    this.notifyHouseholdChanged()
  }

  notifyHouseholdChanged(): void {
    this._householdChanged.next();
  }

  notifyStockChanged(): void {
    this._stockChanged.next();
  }

  notifyShoppingListChanged(): void {
    this._shoppingListChanged.next();
  }

  notifyRecipeChanged(): void {
    this._recipeChanged.next();
  }

  constructor() { }
}
